var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaverse3DSpaceDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3faff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59,49.3c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m51.37,26.7c-.41,0-.75-.34-.75-.75V8.62c0-.41.34-.75.75-.75s.75.34.75.75v17.32c0,.41-.34.75-.75.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.63,32.51c-.41,0-.75-.34-.75-.75v-13.44c0-.41.34-.75.75-.75s.75.34.75.75v13.44c0,.41-.34.75-.75.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1,49.3c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.64,52.75c-.08,0-.17-.01-.25-.04l-19.57-6.83s-.05-.01-.08-.02l-9.63-3.34c-.39-.14-.6-.56-.46-.96.14-.39.56-.59.96-.46l9.57,3.32s.05.01.08.02l19.63,6.85c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.29,56.2c-.08,0-.17-.01-.25-.04l-29.5-10.29c-.31-.09-.53-.38-.53-.72,0-.41.33-.75.74-.75h.02c.08,0,.17.01.25.04l29.52,10.3c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.36,52.75c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l19.64-6.85s.06-.02.08-.02l9.55-3.32c.39-.14.82.07.95.46.14.39-.07.82-.46.95l-9.62,3.34s-.06.02-.08.02l-19.57,6.83c-.08.03-.17.04-.25.04Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.71,56.2c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l29.52-10.3c.47-.16,1.01.21,1.01.71,0,.36-.25.66-.58.73l-29.45,10.28c-.08.03-.17.04-.25.04Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.99,49.3c-.08,0-.17-.01-.25-.04l-28.75-10.02L1.25,49.26c-.39.13-.82-.07-.96-.46-.14-.39.07-.82.46-.96l28.99-10.1c.16-.06.33-.06.49,0l28.99,10.1c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,59.98c-.09,0-.18-.02-.26-.05L.74,49.25c-.3-.11-.5-.41-.49-.73.01-.32.23-.6.54-.69.17-.05.35-.04.5.03l28.71,10.58,28.67-10.56c.16-.08.35-.1.53-.04.31.09.54.37.55.69s-.18.62-.49.73l-29,10.68c-.08.03-.17.05-.26.05Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59,49.3c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m51.37,26.7c-.41,0-.75-.34-.75-.75V8.62c0-.41.34-.75.75-.75s.75.34.75.75v17.32c0,.41-.34.75-.75.75Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.63,32.51c-.41,0-.75-.34-.75-.75v-13.44c0-.41.34-.75.75-.75s.75.34.75.75v13.44c0,.41-.34.75-.75.75Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1,49.3c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.64,52.75c-.08,0-.17-.01-.25-.04l-19.57-6.83s-.05-.01-.08-.02l-9.63-3.34c-.39-.14-.6-.56-.46-.96.14-.39.56-.59.96-.46l9.57,3.32s.05.01.08.02l19.63,6.85c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.29,56.2c-.08,0-.17-.01-.25-.04l-29.5-10.29c-.31-.09-.53-.38-.53-.72,0-.41.33-.75.74-.75h.02c.08,0,.17.01.25.04l29.52,10.3c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.36,52.75c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l19.64-6.85s.06-.02.08-.02l9.55-3.32c.39-.14.82.07.95.46.14.39-.07.82-.46.95l-9.62,3.34s-.06.02-.08.02l-19.57,6.83c-.08.03-.17.04-.25.04Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.71,56.2c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l29.52-10.3c.47-.16,1.01.21,1.01.71,0,.36-.25.66-.58.73l-29.45,10.28c-.08.03-.17.04-.25.04Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.99,49.3c-.08,0-.17-.01-.25-.04l-28.75-10.02L1.25,49.26c-.39.13-.82-.07-.96-.46-.14-.39.07-.82.46-.96l28.99-10.1c.16-.06.33-.06.49,0l28.99,10.1c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,59.98c-.09,0-.18-.02-.26-.05L.74,49.25c-.3-.11-.5-.41-.49-.73.01-.32.23-.6.54-.69.17-.05.35-.04.5.03l28.71,10.58,28.67-10.56c.16-.08.35-.1.53-.04.31.09.54.37.55.69s-.18.62-.49.73l-29,10.68c-.08.03-.17.05-.26.05Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,33.58c-.13,0-.26-.03-.38-.1l-12.61-7.28c-.23-.13-.38-.38-.38-.65v-14.56c0-.27.14-.52.38-.65l12.61-7.28c.23-.13.52-.13.75,0l12.61,7.28c.23.13.38.38.38.65v14.56c0,.27-.14.52-.38.65l-12.61,7.28c-.12.07-.25.1-.38.1Zm-11.86-8.46l11.86,6.85,11.86-6.85v-13.69l-11.86-6.85-11.86,6.85v13.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,19.02c-.13,0-.26-.03-.38-.1l-12.61-7.28c-.36-.21-.48-.67-.27-1.02.21-.36.66-.48,1.02-.27l12.23,7.06,12.23-7.06c.36-.21.82-.08,1.02.27.21.36.08.82-.27,1.02l-12.61,7.28c-.12.07-.25.1-.38.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,33.58c-.41,0-.75-.34-.75-.75v-14.56c0-.41.34-.75.75-.75s.75.34.75.75v14.56c0,.41-.34.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.68,28.23c-.13,0-.26-.03-.38-.1-.23-.13-.38-.38-.38-.65v-12.28c0-.27.14-.52.38-.65l10.63-6.14c.23-.13.52-.13.75,0s.38.38.38.65v12.28c0,.27-.14.52-.38.65l-10.63,6.14c-.12.07-.25.1-.38.1Zm.75-12.59v10.55l9.13-5.27v-10.55l-9.13,5.27Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverse3DSpaceDevelopment);
export default __webpack_public_path__ + "static/media/Metaverse 3D Space Development.0d710f0eb3ca761c342e53c0b26bf379.svg";
export { ForwardRef as ReactComponent };